import React from 'react';
import { Link } from 'react-router-dom';

// New UI only (docs/ui_redesign/18-ux-review.md, R24): an address that matches no screen says so, with a way back.
// Classic shows an empty page there, as before.
export default function NotFound() {
	return (
		<div className="apw2-notfound" role="status">
			<h1>Page not found</h1>
			<p>This address doesn&rsquo;t match a screen in APWorks. It may have moved, or you may not have access to it.</p>
			<Link className="apw2-btn primary" to="/">Go to the dashboard</Link>
		</div>
	);
}
